import { render, staticRenderFns } from "./Normal.vue?vue&type=template&id=ff0fc1cc&scoped=true&"
import script from "./Normal.vue?vue&type=script&lang=ts&"
export * from "./Normal.vue?vue&type=script&lang=ts&"
import style0 from "./Normal.vue?vue&type=style&index=0&id=ff0fc1cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0fc1cc",
  null
  
)

export default component.exports